import React from 'react';
import styles from './CookieBanner.module.scss';
import { handleCookieConsent } from '../../generic/cookieUtils';

interface CookieBannerProps {
  onConsent: () => void;
  onReject: () => void;
}

function CookieBanner({ onConsent, onReject }: CookieBannerProps) {
  const handleAcceptCookies = () => {
    handleCookieConsent(true);
    onConsent();
  };

  const handleRejectCookies = () => {
    handleCookieConsent(false);
    onReject();
  };
  return (
    <div id="cookie-banner" className={styles.cookieBanner}>
      <div className={styles.cookieText}>
        <p>
          We use cookies for the sole purpose of analyzing web traffic to
          improve our website and enhance user experience.{' '}
          <a
            href="https://www.dhigroup.com/cookies"
            target="_blank"
            rel="noreferrer"
          >
            Read more about cookies
          </a>
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.cookieAccept} onClick={handleAcceptCookies}>
          {/* <div>icon</div> */}
          <div>Accept Cookies</div>
        </button>
        <button className={styles.cookieReject} onClick={handleRejectCookies}>
          Reject
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
